<template>
  <div class="mainDiv">
    <el-form ref="queryCondition" :model="queryCondition">
      <el-row>
        <el-col :span="5">
          用户名
          <el-input size="mini" v-model="queryCondition.username" clearable placeholder="请输入内容"
                    class="dialogDataWidth" style="width: 60%;"></el-input>
        </el-col>

        <el-col :span="5">
          真实姓名
          <el-input size="mini" v-model="queryCondition.realname" clearable placeholder="请输入内容"
                    class="dialogDataWidth" style="width: 60%;"></el-input>
        </el-col>

        <el-col :span="5">
          角色
          <el-select size="mini" v-model="queryCondition.roleId" clearable placeholder="请选择" class="dialogDataWidth"
                     style="width: 60%;">
            <el-option v-for="item in options_roleType" :key="item.id" :label="item.roleName" :value="item.id">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="5">
          部门
          <el-cascader class="DataWidth" v-model="queryCondition.deptId" :options="alldeps" :props="deptProps"
                       :show-all-levels="false" size="mini">
          </el-cascader>
        </el-col>

        <el-col :span="4">
          <el-button type="primary" size="mini" @click='query(1)' icon="el-icon-search">查询</el-button>
          <el-button type="primary" plain size="mini" @click='reset' icon="el-icon-refresh">重置</el-button>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px;">
        <el-col :span="4">
          <el-button type="primary" size="mini" @click='userAdd' icon="el-icon-plus">新增</el-button>
          <el-button type="primary" plain size="mini" @click='helpDoc' >帮助</el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-table class="el-table" stripe size="mini" :data="pagedata.content" align="center" style="margin-top: 10px;"
              header-row-class-name="tableHeader">
      <el-table-column align='center' prop="id" type="index" label="序号" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="username" label="用户名" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="realname" label="真实姓名" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="deptName" label="部门" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="roleName" label="角色" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="sex" label="性别" :formatter="formatSex"
                       label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="mobile" label="手机" label-class-name="greenLabel"></el-table-column>
      <!-- <el-table-column align='center' prop="email" label="邮箱" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="tel" label="座机" label-class-name="greenLabel"></el-table-column> -->
      <!-- <el-table-column align='center' prop="status" label="状态" :formatter="formatStatus" label-class-name="greenLabel"></el-table-column> -->
      <el-table-column fixed="right" align="center" label="操作" width="300">
        <template slot-scope="scope">
          <!-- <el-tooltip content="查看" placement="top" effect="light">
            <el-button @click="userView(scope.row)" icon="el-icon-zoom-in" size="small"></el-button>
          </el-tooltip> -->
          <el-tooltip content="编辑" v-if="scope.row.id != 1" placement="top" effect="light">
            <el-button @click="userEdit(scope.row)" icon="el-icon-edit" size="small"></el-button>
          </el-tooltip>
          <el-tooltip content="重置密码" v-if="scope.row.id != 1" placement="top" effect="light">
            <el-button @click="passwordReset(scope.row)" icon="el-icon-refresh" size="small"></el-button>
          </el-tooltip>
          <el-tooltip content="删除" v-if="scope.row.id != 1" placement="top" effect="light">
            <el-button type="danger" plain @click="userDelete(scope.row)" icon="el-icon-delete"
                       size="small"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-size="pagedata.size"
      layout="total, prev, pager, next, jumper"
      :total="pagedata.totalElements"
      :current-page.sync="pagedata.number"
      @current-change="query" class="mb">
    </el-pagination>

    <el-dialog v-if="addVisible" :title="dialogTitle" :visible.sync="addVisible" :fullscreen="false" @close="query"
               :close-on-click-modal="false" width="1000px">
      <user :examUser="userRow" :isSave="isSave" @closeUser="closeUser"></user>
    </el-dialog>

  </div>
</template>
<script>
  import user from '@/components/user/user'

  export default {
    name: 'userList',
    components: {
      user,
    },
    mounted: function () {
      this.getDetpTree();
      this.getRoleList();
      this.query();
    },
    data() {
      return {
        msg: 'this is user',
        loginUserRoleId: '',
        userRow: {
          username: '',
          realName: '',
          status: 1,
          sex: 1,
          roleId: [],
          deptId: '',
          sort: 9999
        },
        addVisible: false,
        dialogTitle: '',
        isSave: true,
        queryCondition: {
          username: '',
          realname: '',
          roleId: '',
          deptId: 1
        },
        pagedata: {
          content: [],
          totalElements: 0,
          totalPages: 1,
          size: 10,
          number: 1,
        },
        alldeps: [],
        deptProps: {
          label: 'label',
          value: 'id',
          children: 'children',
          emitPath: false,
          checkStrictly: true
        },
        options_roleType: [],
        options_sex: [],
        options_status: [],
      }
    },
    methods: {
      closeUser: function () {
        this.query();
        this.addVisible = false;
        this.isSave = false;
      },
      getDetpTree: function () {
        let that = this;
        this.$axios.get("/department/departmentTree").then(response => {
          if (response.data !== null && response.data !== '' && response.data !== undefined) {
            that.alldeps = JSON.parse(response.data);
          }
        })
      },
      //查询角色代码
      getRoleList: function () {
        var url = '/role/allroleList';
        this.$axios.get(url).then(response => {
          if (response.data !== null && response.data !== '' && response.data !== undefined) {
            this.options_roleType = response.data;
          }
        })
      },
      // 查询按钮
      query: function (currentPage) {
        if (!isNaN(currentPage) && currentPage > 0) {
          this.pagedata.number = currentPage;
        }
        var url = '/user/userPage?';
        url += 'username=' + this.queryCondition.username;
        url += '&realname=' + this.queryCondition.realname;
        url += '&roleId=' + this.queryCondition.roleId;
        url += '&deptId=' + this.queryCondition.deptId;
        url += '&pageNumber=' + this.pagedata.number + '&pageSize=' + this.pagedata.size;
        this.$axios.get(url).then(response => {
          if (response.data !== null && response.data !== '' && response.data !== undefined) {
            this.pagedata = response.data;
          }
        })
      },
      reset: function () {
        //清空查询条件
        this.queryCondition.username = '';
        this.queryCondition.realname = '';
        this.queryCondition.roleId = '';
        this.queryCondition.deptId = '';
        this.query(1);
      },
      userView: function (row) {
        this.dialogTitle = '查看用户';
        row.js = [];
        row.js.push(row.userroles[0].roleId);
        this.userRow = row;
        this.isSave = false;
        this.addVisible = true;
      },
      userEdit: function (row) {
        this.dialogTitle = '编辑用户信息';
        this.userRow = row;
        this.userRow.roleId = [];
        var temp = row.roleIds.split(',');
        for (var i = 0; i < temp.length; i++) {
          this.userRow.roleId.push(Number(temp[i]))
        }
        this.isSave = true;
        this.addVisible = true;
      },

      userAdd: function () {
        this.dialogTitle = '新增用户';
        this.userRow = {};
        this.userRow.roleId = []
        this.userRow.status = "1";
        this.userRow.sort = 9999;
        //this.userRow.sex = 1;
        this.isSave = true;
        this.addVisible = true;
      },

      //密码重置
      passwordReset: function (row) {
        this.$confirm('确定要重置密码么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.get('/user/passwordReset?id=' + row.id).then(response => {
            this.query();
            this.$message({
              type: 'success',
              message: '重置密码成功，密码为888888'
            });
          });
        })
      },
      userDelete: function (row) {
        this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.get('/user/userDelete?id=' + row.id).then(response => {
            this.query();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          });
        })
      },
      //状态改成汉字
      formatSex(row, column) {
        if (row.sex == '1') {
          return '男';
        }
        if (row.sex == '2') {
          return '女';
        }
      },
      formatStatus(row, column) {
        if (row.status == '1') {
          return '启用';
        }
        if (row.status == '2') {
          return '停用';
        }
      },
      formatRoleType(row, column) {
        for (var i = 0; i < this.options_roleType.length; i++) {
          if (this.options_roleType[i].id == row.roleId) {
            return this.options_roleType[i].roleName;
          }
        }
      },
      helpDoc(){
        window.localStorage.setItem(this.GLOBAL.VIEW_FILE,JSON.stringify({
          title: "帮助手册",
          downloadUrl: '../browser/systemHelp.pdf',
        }));
        window.open('./static/html/pdf.html');
      },
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/list.vue